const translations = {
  "en": {
    "Final Score": "Final Score"
  },
  "zh-tw": {
    "Final Score": "最終分數"
  }
};

export default translations;
